/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { multicall } from "../utils/contracts";
import axios from "axios";
import _ from "lodash";
import { UNIV3_ADDR, UNIV3_LP_ADDR } from "../abis/address";
import pools from "../tokens/pools";
import UniswapMathABI from "../abis/UniswapMathABI.json";
import UniV3LPABI from "../abis/UniV3LPABI.json";
import { BigNumber, ethers } from "ethers";
import IUniswapV3Pool from "../abis/IUniswapV3Pool.json";
import { Pool } from "@uniswap/v3-sdk/";
import { Token } from "@uniswap/sdk-core";
const provider = new ethers.providers.JsonRpcProvider(
  "https://arb1.arbitrum.io/rpc"
);

const defaultVal = {
  tokenAmounts: [],
  tokenAddress: [],
  tokenRates: [],
  tokenRatios: [],
  lpPrices: [],
  price: 0,
};

export const PoolsInfoContext = React.createContext(defaultVal);

export default function usePoolsInfo() {
  return React.useContext(PoolsInfoContext);
}
let dataid = null;

export function PoolsInfoProvider({ children }) {
  const [price, setPrice] = useState(0);
  const [tokenAmounts, setAmounts] = useState([]);
  const [tokenRates, setRates] = useState([]);
  const [tokenAddress, setTokenAddress] = useState([]);
  const [tokenRatios, setRatios] = useState([]);
  const [lpPrices, setLPPrices] = useState([]);

  //add to database
  async function getAmounts() {
    let calls = [];
    for (let i = 0; i < pools.length; i++) {
      calls.push({
        address: UNIV3_ADDR,
        name: "getReserveLiquidityNFT",
        params: [pools[i].pairAddress, pools[i].tokenID],
      });
    }
    let result = await multicall(UniswapMathABI, calls);
    if (result) {
      setAmounts(result);
      let _rates = [];
      for (let i = 0; i < pools.length; i++) {
        let _rate =
          ethers.utils.formatEther(result[i][0]) /
          ethers.utils.formatEther(result[i][1]);
        if (i == 7) {
          _rate *= Math.pow(10, 10);
          console.log(_rate);
        }
        if (i == 15) {
          _rate /= Math.pow(10, 12);
          console.log(_rate);
        }

        _rates.push(_rate);
      }
      setRates(_rates);
    }
  }

  async function getPoolImmutables(poolContract) {
    const immutables = {
      factory: await poolContract.factory(),
      token0: await poolContract.token0(),
      token1: await poolContract.token1(),
      fee: await poolContract.fee(),
      tickSpacing: await poolContract.tickSpacing(),
      maxLiquidityPerTick: await poolContract.maxLiquidityPerTick(),
    };
    return immutables;
  }

  async function getPoolState(poolContract) {
    const slot = await poolContract.slot0();
    const PoolState = {
      liquidity: await poolContract.liquidity(),

      sqrtPriceX96: slot[0],
      tick: slot[1],
      observationIndex: slot[2],
      observationCardinality: slot[3],
      observationCardinalityNext: slot[4],
      feeProtocol: slot[5],
      unlocked: slot[6],
    };
    return PoolState;
  }

  //add to database
  async function getLPTokenAddress() {
    let calls = [];
    for (let i = 0; i < pools.length; i++) {
      calls.push({
        address: UNIV3_LP_ADDR,
        name: "deposits",
        params: [pools[i].tokenID],
      });
    }
    let result = await multicall(UniV3LPABI, calls);
    if (result) setTokenAddress(result);
  }
  //add to database
  async function getTokenRatios() {
    let _tokenRatios = [];
    for (let i = 0; i < pools.length; i++) {
      const poolContract = new ethers.Contract(
        pools[i].pairAddress,
        IUniswapV3Pool,
        provider
      );
      const { sqrtPriceX96 } = await poolContract.slot0();
      const sqrtRatioX96 = sqrtPriceX96.mul(sqrtPriceX96);
      var ratio = sqrtRatioX96
        .mul(BigNumber.from(10).pow(18))
        .div(BigNumber.from(2).pow(192));
      if (
        pools[i].pairAddress == "0x2f5e87c9312fa29aed5c179e456625d79015299c"
      ) {
        console.log("test");
        ratio = ratio.div(Math.pow(10, 10));
      }
      if (
        pools[i].pairAddress == "0x81c48d31365e6b526f6bbadc5c9aafd822134863"
      ) {
        console.log("arb usdc");
        ratio = ratio.mul(Math.pow(10, 12));
      }
      _tokenRatios.push(ratio);
    }
    setRatios(_tokenRatios);
  }

  async function fetchPriceWithRetry(url) {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  }
  //add to database
  async function fetchPrices() {
    let _poolCount = pools.length;
    let _lpPrices = [];
    for (let i = 0; i < _poolCount; i++) {
      if (
        !pools[i].tokenPriceIds[0] ||
        pools[i].tokenPriceIds[1] === "" ||
        pools[i].tokenPriceIds[0] === "gmusd"
      ) {
        if (pools[i].tokenPriceIds[1] === "") {
          let _price2 = await fetchPrice1(pools[i].tokenPriceIds[1]);
          let data2 = await fetchPriceWithRetry(
            `https://api.coingecko.com/api/v3/coins/${pools[i].tokenPriceIds[0]}?tickers=false&community_data=false&developer_data=false`
          );
          let _price1 = data2 ? data2.market_data.current_price.usd : 0;
          _lpPrices.push([parseFloat(_price1), _price2]);
        } else {
          let _price1 = await fetchPrice1(pools[i].tokenPriceIds[0]);
          let data2 = await fetchPriceWithRetry(
            `https://api.coingecko.com/api/v3/coins/${pools[i].tokenPriceIds[1]}?tickers=false&community_data=false&developer_data=false`
          );
          let _price2 = data2 ? data2.market_data.current_price.usd : 0;
          _lpPrices.push([parseFloat(_price1), _price2]);
        }
      } else {
        let data = await fetchPriceWithRetry(
          `https://api.coingecko.com/api/v3/coins/${pools[i].tokenPriceIds[0]}?tickers=false&community_data=false&developer_data=false`
        );
        let _price1 = data ? data.market_data.current_price.usd : 0;

        let data2 = await fetchPriceWithRetry(
          `https://api.coingecko.com/api/v3/coins/${pools[i].tokenPriceIds[1]}?tickers=false&community_data=false&developer_data=false`
        );
        let _price2 = data2 ? data2.market_data.current_price.usd : 0;
        _lpPrices.push([_price1, _price2]);
      }
    }
    console.log(_lpPrices);
    setLPPrices(_lpPrices);
  }
  // pool address
  const poolAddress = "0x99db8DBA7b30aB3C6447C4388d81dcc27C5A8b61";
  const poolAddress1 = "0x3bB5690832AdED8D217D257583c189C7f0093fe9";

  async function fetchPrice1(tokenName) {
    let _poolAddress = tokenName === "gmusd" ? poolAddress1 : poolAddress;
    const poolContract = new ethers.Contract(
      _poolAddress,
      IUniswapV3Pool,
      provider
    );
    const immutables = await getPoolImmutables(poolContract);
    const state = await getPoolState(poolContract);
    const GND = new Token(42161, immutables.token0, 18, "GND", "GND Coin");
    const USDC = new Token(42161, immutables.token1, 6, "USDC", "USDC Coin");

    //create a pool
    const GND_USDC_POOL = new Pool(
      USDC,
      GND,
      immutables.fee,
      state.sqrtPriceX96.toString(),
      state.liquidity.toString(),
      state.tick
    );
    const price1 = await GND_USDC_POOL.token0Price;
    const price2 = await GND_USDC_POOL.token1Price;
    console.log("Price", price1.toFixed(2));
    if (tokenName !== "gmusd") setPrice(Number(price1.toFixed(10)));
    return price1.toFixed(2);
  }

  useEffect(() => {
    getAmounts();
    getLPTokenAddress();
    getTokenRatios();
    if (dataid) clearInterval(dataid);
    dataid = setInterval(() => {
      getAmounts();
      getTokenRatios();
    }, 100000);
  }, []);

  return (
    <PoolsInfoContext.Provider
      value={{
        tokenAmounts,
        tokenAddress,
        tokenRates,
        tokenRatios,
        lpPrices,
        price,
        fetchPrices,
      }}
      children={children}
    />
  );
}
